export const products = [
  {
    id: 'golden_morning',
    name: 'Golden Morning',
    origin: '',
    tagline: 'Soft. Golden. Effortless.',
    description: 'A smooth, mellow honey with soft buttery notes and a subtle nuttiness. Golden to amber in colour.',
    longDescription: 'A smooth, mellow honey gathered from bees foraging on Grey Box eucalyptus blossoms in Victoria. With soft buttery notes, a subtle nuttiness, and a golden amber glow, this beautifully balanced honey is made for everyday sweetness.',
    sizes: ['500g'],
    price: { '500g': 15.95 },
    image: 'https://customer-assets.emergentagent.com/job_bee-harvest-6/artifacts/s99977ll_Jar%20Update.jpg',
    imageFilter: 'brightness(1) contrast(1.05) saturate(1)',
    imageScale: 1,
    color: 'Light golden amber',
    taste: 'Delicate, buttery, slightly floral',
    uses: 'Toast, tea, baking, salad dressings'
  },
  {
    id: 'river_bloom',
    name: 'River Bloom',
    origin: '',
    tagline: 'Bright. Smooth. Sweet.',
    description: 'Light, bright and delicately sweet, this honey has a clean, fresh flavour.',
    longDescription: 'Light, bright and delicately sweet, this honey has a clean, fresh flavour. Collected from riverside blossoms along the Murray\u2013Darling Basin, it\'s a gentle and versatile honey perfect for the whole family.',
    sizes: ['500g'],
    price: { '500g': 16.95 },
    image: 'https://customer-assets.emergentagent.com/job_bee-harvest-6/artifacts/643vr0tw_RB%20Update.jpg',
    imageFilter: 'brightness(1) contrast(1.05) saturate(1)',
    imageScale: 1,
    color: 'Light amber with golden highlights',
    taste: 'Clean, smooth, subtly floral',
    uses: 'Breakfast, smoothies, natural sweetener, kids\' snacks'
  },
  {
    id: 'wild_forest',
    name: 'Wild Forest',
    origin: '',
    tagline: 'Rich. Deep. Untamed.',
    description: 'Rich, dark and full-bodied, this honey delivers a bold flavour with depth and intensity.',
    longDescription: 'Rich, dark and full-bodied, this honey delivers a bold flavour with depth and intensity. Harvested from the forests of Cobboboonee National Park near Portland, it\'s a true standout for those who love a stronger honey.',
    sizes: ['500g'],
    price: { '500g': 17.95 },
    image: 'https://customer-assets.emergentagent.com/job_bee-harvest-6/artifacts/lyhlfqvk_WF%20Extract.jpg',
    imageFilter: 'brightness(1) contrast(1.05) saturate(1)',
    imageScale: 1,
    color: 'Deep amber',
    taste: 'Bold, earthy, complex with caramel notes',
    uses: 'Cheese boards, marinades, cocktails, cooking'
  },
  {
    id: 'honey_bundle',
    name: 'The Complete Collection',
    origin: '',
    tagline: 'All three honeys. One perfect bundle.',
    description: 'Experience the full range of Ricky\'s Bees honey with our complete collection. Save when you buy all three varieties together.',
    longDescription: 'Our Complete Collection brings together all three of our signature honeys in one bundle. Perfect for discovering your favorite or gifting to a honey lover. Includes Golden Morning, River Bloom and Wild Forest - each 500g jar showcasing unique flavors from Victoria. Save $2.90 when you purchase the complete collection.',
    sizes: ['Bundle (3 x 500g)'],
    price: { 'Bundle (3 x 500g)': 47.95 },
    outOfStock: true,
    image: 'https://customer-assets.emergentagent.com/job_bee-harvest-6/artifacts/b5exqsbc_ChatGPT%20Image%20May%2016%2C%202026%2C%2009_38_46%20PM.png',
    imageFilter: 'brightness(1) contrast(1.05) saturate(1)',
    color: 'Three distinct varieties',
    taste: 'Light to bold - explore them all',
    uses: 'Perfect for gifts, tasting, or stocking your pantry'
  }
];

export const getProductById = (id) => {
  return products.find(product => product.id === id);
};

